if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };

        this.submitEl.addEventListener('click', this.onClick.bind(this));
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('.sticky-atc-bar__submit'));
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.init();

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this._resizeHandler) {
          window.removeEventListener('resize', this._resizeHandler);
        }
      }

      init() {
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        const isMobile = () => window.innerWidth < 768;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (isMobile()) {
                // Mobile: show bar whenever buy buttons are NOT visible
                this.classList.toggle(this.classes.isOpen, !entry.isIntersecting);
              } else {
                // Desktop: only show when scrolled past buy buttons
                const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.classList.toggle(this.classes.isOpen, isAboveViewport);
              }
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.productFormActions);

        // Re-evaluate on resize (mobile <-> desktop transition)
        this._resizeHandler = () => {
          if (this.observer) {
            this.observer.disconnect();
            this.observer.observe(this.productFormActions);
          }
        };
        window.addEventListener('resize', this._resizeHandler);

        this.syncWithMainProductForm();
      }

      onClick() {
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        window.scrollTo({
          behavior: 'smooth',
          top: target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
        });
      }

      updateButton(disable = true, text, modifyClass = true) {
        const addButton = this.submitEl;
        if (!addButton) return;

        const labelEl = addButton.querySelector('.sticky-atc-bar__submit-label');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) labelEl.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          labelEl.textContent = 'Ajouter au panier';
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
